import type React from "react";

import { faStars } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { useGetTherapistRating } from "api/services/therapist/hooks";
import { NoGraphData } from "routes/admin/components/NoGraphData";
import { SkeletonLayout } from "shared/atoms/SkeletonLayout";
import { WidgetBox } from "shared/containers/WidgetBox";
import { BLUE } from "theme/colors";

export const Rating: React.FC = () => {
  const { t } = useTranslation();
  const { data: therapistRatingData, isLoading } = useGetTherapistRating();

  const data = therapistRatingData?.rating;
  const hasData = data !== undefined && data !== null;

  return (
    <StyledWidgetBox
      title={t("dashboard.therapist_rating.title")}
      description={t("dashboard.therapist_rating.description")}
      icon={<FontAwesomeIcon icon={faStars} />}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "240px" }}>
        {isLoading && <SkeletonLayout layout={{ type: "skeleton", variant: "text", typographyVariant: "h2" }} />}
        {!isLoading && !hasData && <NoGraphData title={t("patients.graph.no_data")} />}
        {!isLoading && hasData && (
          <Typography variant="h1" fontSize="80px" color={BLUE[100]}>
            {data}
          </Typography>
        )}
      </Box>
    </StyledWidgetBox>
  );
};

const StyledWidgetBox = styled(WidgetBox)`
  box-sizing: border-box;
  height: 100%;
`;
